import BaseService from '../base';

class Country extends BaseService {}

export default new Country('countries', 'Country');
